type NoopLogger = {
	logger: {
		log: (...args: unknown[]) => void;
		debug: (...args: unknown[]) => void;
		info: (...args: unknown[]) => void;
		warn: (...args: unknown[]) => void;
		error: (...args: unknown[]) => void;
	};
};

const noop = () => void 0;

export const useDatadogLogs = (): NoopLogger => {
	return {
		logger: {
			log: noop,
			debug: noop,
			info: noop,
			warn: noop,
			error: noop,
		},
	};
};
